import { render, staticRenderFns } from "./psuConfirmIndex.vue?vue&type=template&id=c1b1a3d6&"
import script from "./psuConfirmIndex.vue?vue&type=script&lang=js&"
export * from "./psuConfirmIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports